<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Add requirement</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Competency</label>
            <p-multiSelect
              class="form-control"
              formControlName="competency"
              [options]="competencyOptions"
              defaultLabel="Select requirement..."
              required="true"
              [style]="{ width: '100%' }"
              filter="true"
            ></p-multiSelect>
          </div>
        </div>
        <div class="col-md-12" *ngIf="form.value.competency">
          <ul>
            <li>requires certificate</li>
            <li>requires Site Operator approval</li>
          </ul>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
